import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/assets/card-printer/")({
    beforeLoad: () => { throw redirect({ to: "/assets/card-printer/printers" }); },
});
